import React from 'react'
import { CLASS_PREFIX } from 'src/constants'
import { textResources } from 'src/lang/de'
import './project_not_found.scss'

const cls = CLASS_PREFIX + 'project-not-found'

const t = textResources.projects

export const ProjectNotFound: React.FC = () => (
  <div className={cls}>
    <h1>{t.common.notFound}</h1>
  </div>
)
